export default __webpack_public_path__ + "images/ef9b9d8cbb1e8200c99c0f260a95909a-baby_small.webp";